require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-the-ultimate-list-of-ux-design-and-development-resources.json") })
        }
      }, "path---blog-the-ultimate-list-of-ux-design-and-development-resources");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-the-ultimate-list-of-ux-design-and-development-resources!./.cache/json/blog-the-ultimate-list-of-ux-design-and-development-resources.json
// module id = 1103
// module chunks = 231608221292675